import {
    Box, chakra, Flex, Text
} from '@chakra-ui/react';
import { SystemStyleObject } from '@chakra-ui/styled-system';

import { Button as ThemedButton } from '@components';

const getWmdBannerStyles = (variant: string): SystemStyleObject => {
    switch (variant) {
    case 'promotion': return {
        backgroundColor: '#F5BC23',
        borderRadius: '20px'
    };
    case 'warmup': return {
        background: 'linear-gradient(90deg, #FEAD78 0%, #FEC86C 51.45%, #FDAE79 102.89%)',
        borderRadius: '24px',
        border: '2px solid rgba(255, 255, 255, 0.80)'
    };
    case 'event': return {
        position: 'relative',
        background: 'linear-gradient(90deg, #FDB078 0%, #F5BC23 25.5%, #69F1C7 65.5%, #58C6FF 100%)',
        borderRadius: '24px',
        border: '2px solid rgba(255, 255, 255, 0.70)',
        _before: {
            content: "''",
            height: '80px',
            borderRadius: '20px',
            // eslint-disable-next-line max-len
            background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.00) 100%), linear-gradient(90deg, #E97C2D 0%, #D39B06 30%, #20D19B 65%, #178BC8 100%)',
            position: 'absolute',
            top: '6px',
            width: 'calc(100% - 20px)',
            margin: '0 10px',
            zIndex: -1
        }
    };
    default: return {};
    }
};

export const getWmdContainer = (variant: string) => chakra(Box, {
    baseStyle: {
        width: '100%',
        minWidth: '586px',
        maxWidth: '1120px',
        position: 'relative',
        height: '80px',
        marginTop: '36px',
        ...getWmdBannerStyles(variant)
    }
});

export const wrapper = chakra(Flex, {
    baseStyle: {
        justifyContent: 'space-between',
        flexDirection: 'row',
        alignItems: 'center',
        padding: {
            base: '0 8px',
            tablet: '0 32px',
            portrait: '0 32px'
        },
        height: '100%'
    }
});

const centerAlignmentBanner = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%'
};

export const rays = chakra(Box, {
    baseStyle: {
        maxWidth: '1011px',
        ...centerAlignmentBanner
    }
});

export const logo = chakra(Box, {
    baseStyle: {
        ...centerAlignmentBanner,
        transform: 'translate(-50%, -44%)'
    }
});

export const stars = chakra(Box, {
    baseStyle: {
        height: '100%',
        position: 'absolute',
        left: '-15px',
        top: '-12px'
    }
});

export const bannerTextDefault = {
    color: 'primary.900',
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '120%',
    letterSpacing: '-0.2px',
    fontFamily: 'Poppins'
};

export const textLeft = chakra(Text, {
    baseStyle: {
        justifyContent: 'flex-start',
        zIndex: 2,
        ...bannerTextDefault
    }
});

export const subTextLeft = chakra(Text, {
    baseStyle: {
        ...bannerTextDefault,
        fontWeight: 400
    }
});

export const textRight = chakra(Text, {
    baseStyle: {
        justifyContent: 'flex-end',
        ...bannerTextDefault
    }
});

export const rightWrapper = chakra(Flex, {
    baseStyle: {
        alignItems: 'center',
        w: '40%',
        justifyContent: 'flex-end',
        gap: {
            base: '0.5em',
            tablet: '1em'
        },
        textAlign: 'right'
    }
});

export const button = chakra(ThemedButton, {
    baseStyle: {
        width: 'auto',
        height: '40px',
        borderRadius: '40px',
        p: {
            base: '0 6px',
            tablet: '0 16px',
            portrait: '0 16px'
        },
        background: 'linear-gradient(104deg, #00ABE8 -2.03%, #007ACC 43.7%, #0063A7 105.46%)',
        fontSize: '16px',
        lineHeight: '24px',
        minWidth: 'fit-content',
        span: {
            marginInlineStart: {
                base: '0.5em',
                tablet: '1em',
                portrait: '1em'
            }
        }
    }
});

export const getLeftTextStyles = (text: string) => {
    const regex = /\bMaths\b/;

    if (regex.test(text)) {
        return text.replace('Maths', 'Math<span style="color: #2E77CD;">s</span>');
    }

    return text;
};
